import { MapTo } from '@adobe/aem-react-editable-components';
import Breadcrumbs, { BreadcrumbsEditConfig } from './Breadcrumbs';

export default MapTo('cob-corp-acquisition/components/creditonebank/breadcrumbs')(Breadcrumbs, BreadcrumbsEditConfig);